'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PasswordPolicyEditForm } from '@/features/identity-policy';
export const Route = createFileRoute('/_staff/idp/_layout/settings/password/edit')({
  component: IdpPasswordPolicyEditPage
});
function IdpPasswordPolicyEditPage() {
  return <PasswordPolicyEditForm backTo="/idp/settings/password" />;
}